import { ReservationGuestDto } from 'gleblu-socket-api';

import { ReservationGuest } from '../../models/interfaces/reservation/Reservation';

export function fromDto(guestDto: ReservationGuestDto): ReservationGuest {
  const { uuid, reservationUuid, firstName, lastName, phoneNumber, email, selectedLanguage } = guestDto;
  return {
    uuid,
    reservationUuid,
    firstName,
    lastName,
    phoneNumber,
    email,
    selectedLanguage,
  };
}

export function toDto(guest: ReservationGuest): ReservationGuestDto {
  const { uuid, reservationUuid, firstName, lastName, phoneNumber, email, selectedLanguage } = guest;
  return {
    uuid,
    reservationUuid,
    firstName,
    lastName,
    phoneNumber,
    email,
    selectedLanguage,
  };
}
